import React, { useContext } from 'react';
import { addDoubleApostrophe } from '../utils';
import { SessionContext } from '../contexts/SessionContext';
import { ChatbotContext } from '../contexts/ChatbotContext';

// This component is used to parse the incoming messages and pass them to the
// appropriate action.
/* eslint-disable react/prop-types */
const MessageParser = ({ children, actions }) => {
  const { setIsPromptRetried } = useContext(SessionContext);
  const { prompt, setPrompt } = useContext(ChatbotContext);
  const parse = (message) => {
    /* message arguments always be empty string due to custom input box implementation
    So manually passing the prompt/message(lives in context) to functions 
    */
    message = prompt;
    setIsPromptRetried(false);
    message = addDoubleApostrophe(message);
    actions.handleUserMessage(message);
  };

  return (
    <div>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          parse: parse,
          actions,
        });
      })}
    </div>
  );
};

export default MessageParser;
